import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CityService } from '../../services/city.service';
import { ContactService } from '../../services/contact.service';
import { CSEService } from '../../services/cse.service';
import { NotificationService } from '../../services/notification.service';
import { Carrier, City, SearchCarrierContact, SearchCityState } from '../../models/models';

@Component({
    selector: 'carrier-quick-add',
    templateUrl: './carrier-quick-add.component.html',
    standalone: false
})
export class CarrierQuickAdd implements OnChanges {
    @Input() countryCode: string = "US";
    @Output() onRefreshCarrier = new EventEmitter<any>();

    public carrier: Carrier = {} as Carrier;
    public contact: SearchCarrierContact = {} as SearchCarrierContact;
    public contactID: number = 0;
    private usPhoneMask: string = "(999) 000-0000";
    private mexicoPhoneMask: string = "99-999-999-9999";
    public phoneFilter: string = "US";
    public phoneMask: string = "(999) 000-0000";
    public isLoading: boolean = false;    
    private carrierCity: SearchCityState = {} as SearchCityState;
    //public cityControl = new FormControl();
    public userEnteredZip: string = "";
    public carrierForm: UntypedFormGroup = new UntypedFormGroup({
        cityStateZipCtrl: new UntypedFormControl(''),
        cityControl: new UntypedFormControl('')
    });

    constructor(private cityService: CityService, private contactService: ContactService,
        private cseService: CSEService, private notificationService: NotificationService) {
    }

    ngOnInit() {
        this.initValues();
        console.log("ngOnInit", this.carrier);
    }

    ngOnChanges() {
        console.log("ngOnChanges", this.carrier);
    }

    private initValues() {
        if (this.countryCode == "MX") {
            this.phoneMask = this.mexicoPhoneMask;
        }
        else {
            this.phoneMask = this.usPhoneMask;
        }
        this.carrier = this.getNewCarrier();
    }

    public saveCarrier() {
        this.isLoading = true;

        //var city = this.carrierForm.controls['cityControl'].value as City;
        //this.carrier.city = this.carrierCity;
        this.carrier.cityID = this.carrierCity.cityID;
        this.userEnteredZip = this.carrierCity.zip;
        if (this.carrierCity.countryAbbr != null) {
            this.countryCode = this.carrierCity.countryAbbr.trim().toUpperCase();
        }

        this.cseService.saveCarrier(this.carrier, this.userEnteredZip).subscribe(result => {
            this.isLoading = false;
            if (result.carrierID > 0) {
                this.carrier = result;
            } else {
                alert('Failed to save Carrier');
            }
            this.contactService.getSearchContactByCarrierID(this.carrier.carrierID).subscribe(result => {
                if (result.resultCollection.length > 0) {
                    var contactList: SearchCarrierContact[] = result.resultCollection;
                    this.contact = contactList.filter(t => t.isDefault == true)[0];
                    if (this.contact != null) {
                        this.contactID = this.contact.contactID;
                    }
                    console.log("carrier-quick-add:contact", this.contactID, this.contact, contactList, this.carrier);
                }
            });
        });

        //this.carrier = {} as Carrier;
    }

    public refreshCarrier() {
        this.onRefreshCarrier.emit(this.carrier.carrierID);
        this.carrier = {} as Carrier;
    }

    public cancelCarrier() {
        this.onRefreshCarrier.emit();
    }

    public getNewCarrier() {
        var newCarrier = {
            carrierID: 0,
            name: "",
            carrierCode: "",
            mcNumber: "",
            scacCode: "",
            dotNumber: "",
            erpCarrierId: "",
            macropointLocationProviderId: 0,
            address1: "",
            address2: "",
            cityID: 0,
            city: {} as City,
            createDate: new Date(),
            excludedFromAutotenderEmail: true,
            excludeRequiredDataBeforeVerifyLoad: true,
            retired: false,
            createdByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
            trucks: 0,
            notes: ""
        } as Carrier;
        return newCarrier;
    }

    public citySTChanged(evt: any) {
        var cityID = evt;
        this.cityService.getCityByID(cityID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.carrierCity = result.resultCollection[0];
                this.carrier.cityID = cityID;
                console.log("cityZipChanged:carrierCity", cityID, this.carrierCity, result);
            }
            else {
                this.notificationService.showWarning("Invalid or missing city.", "WARNING: Invalid City");
            }
        });
    }
}
